import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
export default store => ({
  path: "my-calendar",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "my-calendar" */ "./components"),
        import(
          /* webpackChunkName: "my-calendar" */ "MyCalendar/modules/MyCalendarModule"
        ),
        import(
          /* webpackChunkName: "my-calendar" */ "ClassRoom/modules/ClassRoomModule"
        ),
        import(
          /* webpackChunkName: "my-calendar" */ "Worksheet/modules/WorksheetModules"
        ),
        import(
          /* webpackChunkName: "my-calendar" */ "UnitPlans/modules/UnitPlanModule"
        ),
        import(
          /* webpackChunkName: "my-calendar" */ "Assessments/modules/AssessmentModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const classRoomReducer = importedModule2.default;
          const worksheetModule = importedModule3;
          const unitPlanModule = importedModule4.default;
          const assessmentModule = importedModule5;
          injectReducer(store, {
            key: "myCalendar",
            reducer,
          });
          injectReducer(store, {
            key: "classRoom",
            reducer: classRoomReducer,
          });
          injectReducer(store, {
            key: worksheetModule.NAME,
            reducer: worksheetModule.default,
          });
          injectReducer(store, {
            key: "unitPlans",
            reducer: unitPlanModule,
          });
          injectReducer(store, {
            key: assessmentModule.NAME,
            reducer: assessmentModule.default,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ClassRoomDetails(store)],
});
